import React, { useState, useEffect } from 'react';
import { Card, Tag } from 'antd';
import { useNavigate } from 'react-router-dom';
import styles from './LiveList1.module.scss';
import { LiveStream } from '../../types';
import { useTranslation } from 'react-i18next';





interface LiveList1Props {
  className?: string;
  liveStreams: LiveStream[];
}

const LiveList1: React.FC<LiveList1Props> = ({ className,liveStreams=[] }) => {
  const navigate = useNavigate();
    //国际化语言切换
    const { t } = useTranslation();
  

  const handleStreamClick = (streamId: string) => {
    // 跳转到直播详情页或回放页
    console.log('Navigate to stream:', streamId);
  };

  const handleProductClick = (productId: string, e: React.MouseEvent) => {
    e.stopPropagation();
    // 跳转到商品详情页
    console.log('Navigate to product:', productId);
  };

  const getBadgeColor = (badge: string) => {
    const colorMap: { [key: string]: string } = {
      'MIDNIGHT DEAL': '#1890ff',
      'NEW ARRIVALS': '#52c41a',
      'BEST SELLERS': '#fa541c',
      'MID SEASON SALE': '#722ed1',
      'HOT TREND': '#eb2f96',
      'BUY ONE GET ONE FREE': '#13c2c2',
      'FREE SHIPPING': '#faad14',
      'LUXE FINDS': '#2f54eb',
      'LIVE STREAM': '#f5222d'
    };
    return colorMap[badge] || '#666666';
  };

  return (
    <div className={`${styles.liveList1Container} ${className || ''}`}>
      <div className={styles.sectionTitle}>
        <h2>{t('liveNow.PastLivestreams')}</h2>
      </div>
      
      <div className={styles.streamsGrid}>
        {liveStreams.map((stream) => (
          <Card
            key={stream.id}
            className={styles.streamCard}
            onClick={() => handleStreamClick(stream.id)}
            cover={
              <div className={styles.streamThumbnail}>
                <img 
                  src={stream.thumbnail} 
                  alt={stream.title}
                  onError={(e) => {
                    // 图片加载失败时的处理
                    const target = e.target as HTMLImageElement;
                    target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzUwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZjBmMGYwIi8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCwgc2Fucy1zZXJpZiIgZm9udC1zaXplPSIxNiIgZmlsbD0iIzk5OTk5OSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkxpdmUgU3RyZWFtPC90ZXh0Pjwvc3ZnPg==';
                  }}
                />
                
                {/* 时间倒计时 */}
                {/* {stream.timeLeft && (
                  <div className={styles.timeLeft}>
                    {stream.timeLeft}
                      </div>
                )}
                 */}
                {/* 标签徽章 */}
                {/* <div className={styles.badges}>
                  {stream.badges?.map((badge, index) => (
                    <Tag 
                      key={index} 
                      className={styles.badge}
                      style={{ backgroundColor: getBadgeColor(badge), border: 'none' }}
                    >
                      {badge}
                    </Tag>
                  ))}
                </div> */}
              </div>
            }
          >
            <div className={styles.streamInfo}>
              <h3 className={styles.streamTitle}>{stream.title}</h3>
              
              <div className={styles.authorInfo}>
                <div className={styles.authorAvatar}>
                  <img 
                    src={stream.avatar} 
                    alt={stream.author}
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.style.display = 'none';
                    }}
                  />
                </div>
                <span className={styles.authorName}>{stream.author}</span>
              </div>

              {/* 商品预览 */}
              <div className={styles.productsPreview}>
                {stream.products.slice(0, 3).map((product, index) => (
                  <div 
                    key={product.id} 
                    className={styles.productThumb}
                    onClick={(e) => handleProductClick(product.id, e)}
                    title={`${product.name} - $${product.price}`}
                  >
                    <img 
                      src={product.image} 
                      alt={product.name}
                                  onError={(e) => {
                        const target = e.target as HTMLImageElement;
                        target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0iI2YwZjBmMCIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LWZhbWlseT0iQXJpYWwsIHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMTAiIGZpbGw9IiM5OTk5OTkiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGR5PSIuM2VtIj4/PC90ZXh0Pjwvc3ZnPg==';
                      }}
                    />
                    {stream.products.length > 3 && index === 3 && (
                      <div className={styles.moreProducts}>
                        +{stream.products.length - 3}
                      </div>
                    )}
                  </div>
                ))}
                {stream.products.length > 3 && (
                  <div className={styles.moreIndicator}>
                    +{stream.products.length - 3}
                  </div>
                )}
              </div>
              
              {/* Limited Time 标签 */}
              <div className={styles.limitedTime}>
                <Tag className={styles.limitedTimeTag}>{t('liveNow.LimitedTime')}</Tag>
              </div>
            </div>
          </Card>
        ))}
    </div>
  </div>
  );
};

export default LiveList1;